import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import {
  AllocationViewClearAction,
  AllocationViewClearActionSetInitialState,
} from './allocation-view-clear-action.actions';
import { AllocationViewClearActionService } from './allocation-view-clear-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewClearActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewClearActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsClear',
  defaults: initialState,
})
@Injectable()
export class AllocationViewClearActionState extends AllocationViewActionBaseState {
  static getLoaded(ctx: AllocationViewClearActionStateModel): boolean {
    return ctx.loaded;
  }

  constructor(
    private allocationViewClearActionService: AllocationViewClearActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewClearAction)
  uliClear(
    ctx: StateContext<AllocationViewClearActionStateModel>,
    { payload: { identifier } }: AllocationViewClearAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewClearActionService.uliClear(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.clear');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewClearActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewClearActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
